import React, { useState } from "react";
import { Select, MenuItem, Checkbox, ListItemText } from "@mui/material";
import { Filter } from "react-feather";

/**
 * @param {{
  onFilter?: (value: string[]) => void
  filteredData?: string[],
}} data 
 */
const TableHeadFilter = ({ onFilter, filteredData }) => {
  const [filters, setFilters] = useState([]);
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const handleChange = ({ target: { value } }) => {
    let newValues = [];

    // Normal handling for other columns
    const isFilterExist = filters.includes(value);

    if (!isFilterExist) {
      newValues = [...filters, value];
    } else {
      newValues = filters.filter((filter) => filter !== value);
    }

    onFilter && onFilter(newValues);
    setFilters(newValues);
  };

  return (
    <>
      &nbsp;&nbsp;
      <Filter
        size={12}
        color={filters.length > 0 ? "#2c49fc" : "#879fb5"}
        strokeWidth={filters.length > 0 ? 2.3 : 2}
        onClick={() => setIsFilterOpen(true)}
      />
      <Select
        value={filters}
        sx={{
          visibility: "hidden",
          opacity: 0,
          width: "0px",
          height: "0px",
        }}
        mutliple="true"
        onChange={handleChange}
        open={isFilterOpen}
        onOpen={() => setIsFilterOpen(true)}
        onClose={() => setIsFilterOpen(false)}
      >
        {filteredData.map((item) => (
          <MenuItem
            value={item}
            key={item}
            sx={{
              padding: "2px 8px 2px 6px",
              minHeight: "28px",
              height: "auto",
            }}
          >
            <Checkbox
              size="1"
              checked={filters.includes(item)}
              sx={{
                padding: "2px 4px 2px 0px",
              }}
            />
            <ListItemText
              primary={item === " " ? "(empty)" : item}
              slotProps={{
                primary: {
                  sx: {
                    fontSize: "12px",
                    color: "#879fb5",
                    lineHeight: "18px",
                    fontWeight: "500",
                    fontStyle: item === "" ? "italic" : "normal",
                  },
                },
              }}
            />
          </MenuItem>
        ))}
      </Select>
    </>
  );
};

export default TableHeadFilter;
